import template from './readmissions.html';
import controller from './readmissions.controller';
import './readmissions.styl';

let readmissionsComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default readmissionsComponent;



// WEBPACK FOOTER //
// ./client/app/common/reports/readmissions/readmissions.component.js